import React from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
} from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useSnackbar } from 'notistack'
import { usePostLuckyDrawCompany } from '../../../api/lucky-draw'

const schema = yup.object().shape({
  companyAccountId: yup.string().required('Company ID is required'),
  companyName: yup.string().required('Company Name is required'),
})

const CompanyForm = ({ open, setOpen }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      companyAccountId: '',
      companyName: '',
    },
    resolver: yupResolver(schema),
  })

  const { mutateAsync, isLoading } = usePostLuckyDrawCompany()
  const { enqueueSnackbar } = useSnackbar()

  const onSubmit = async (values) => {
    try {
      await mutateAsync(values)
      enqueueSnackbar('Successfully created', { variant: 'success' })
      reset()
      setOpen(false)
    } catch {
      enqueueSnackbar('Something went wrong. Please try again.', { variant: 'error' })
    }
  }

  return (
    <Dialog maxWidth='sm' open={open} fullWidth>
      <DialogTitle>Create Lucky Draw Company</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <Box mb={2}>
            <Controller
              name='companyAccountId'
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label='Company ID'
                  variant='outlined'
                  fullWidth
                  error={!!errors.companyAccountId}
                  helperText={errors.companyAccountId?.message}
                />
              )}
            />
          </Box>
          <Box mb={2}>
            <Controller
              name='companyName'
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label='Company Name'
                  variant='outlined'
                  fullWidth
                  error={!!errors.companyName}
                  helperText={errors.companyName?.message}
                />
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant='outlined'
            onClick={() => {
              reset()
              setOpen(false)
            }}
          >
            CANCEL
          </Button>
          <Button type='submit' variant='contained' color='primary' disabled={isLoading}>
            SUBMIT
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CompanyForm
